
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/education/[postSlug]",
      function () {
        return require("private-next-pages/education/[postSlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/education/[postSlug]"])
      });
    }
  